import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import RouteName from "../../routes/Route.name";
import {
  actionFetchAppUsers,
  actionSetPageAppUsers,

} from "../../actions/AppUsers.action";
import {serviceExportAppUsersList} from "../../services/AppUsers.service";
import history from "../../libs/history.utils";
import LogUtils from "../../libs/LogUtils";

const useAppUsersListHook = ({}) => {
  const [editData, setEditData] = useState(null);
  const [isSidePanel, setSidePanel] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const isMountRef = useRef(false);
  const {
    sorting_data: sortingData,
    is_fetching: isFetching,
    query,
    query_data: queryData,
    all,
  } = useSelector((state) => state?.appusers);

  useEffect(() => {
    dispatch(
      actionFetchAppUsers(
        1,
        {},
        {
          query: isMountRef.current ? query : null,
          query_data: isMountRef.current ? queryData : null,
        }
      )
    );
    isMountRef.current = true;
  }, []);
  const handleSideToggle = useCallback(
    (data) => {
      setSidePanel((e) => !e);
      if (data) {
        setEditData(data?.id);
      } else {
        setEditData(null);
      }
    },
    [setEditData, setSidePanel]
  );
  const handlePageChange = useCallback((type) => {
    dispatch(actionSetPageAppUsers(type));
  }, []);

  const queryFilter = useCallback(
    (key, value) => {
      dispatch(
        actionFetchAppUsers(1, sortingData, {
          query: key == "SEARCH_TEXT" ? value : query,
          query_data: key == "FILTER_DATA" ? value : queryData,
        })
      );
    },
    [sortingData, query, queryData]
  );

  const handleFilterDataChange = useCallback(
    (value) => {
      const filteredValue = value?.map((item) =>
        item?.name === "is_general"
          ? { ...item, value: item?.value === "YES" }
          : item
      );
      queryFilter("FILTER_DATA", filteredValue);
    },
    [queryFilter]
  );

  const handleSearchValueChange = useCallback(
    (value) => {
      queryFilter("SEARCH_TEXT", value);
    },
    [queryFilter]
  );

  const handleSortOrderChange = useCallback(
    (row, order) => {
      // dispatch(actionSetPageAppUsers(1));
      dispatch(
        actionFetchAppUsers(
          1,
          { row, order },
          {
            query: query,
            query_data: queryData,
          }
        )
      );
    },
    [query, queryData]
  );
  const handleEdit = useCallback(
    (data) => {
      setEditData(data);
      setSidePanel((e) => !e);
    },
    [setEditData, setSidePanel]
  );
  const handleEditSidePannel = useCallback(
    (data) => {
      setSidePanel((e) => !e);
      if (data) {
        setEditData(data);
      } else {
        setEditData(null);
      }
      // setSidePanel((e) => !e);
      // setEditData(data?.id);
    },
    [setSidePanel, setEditData]
  );
  // const handleEdit = useCallback((type) => {
  //   history.push(`${RouteName.PRODUCT_DETAILS}${type?.id}`);
  // }, []);

  const handleCreate = useCallback(() => {
    history.push(RouteName.PRODUCT_CREATE);
  }, []);

  const configFilter = useMemo(() => {
    return [
      
      {
        label: "Status",
        name: "status",
        type: "select",
        fields: ["ACTIVE", "INACTIVE"],
      },
     
    ];
  }, []);

//  const handleCity = useCallback(() => {
//   (data) => {
//   history.push(`${ RouteName.CITY}${data?.id}`);
//   }
// }, [setData]);

const handleDetail = useCallback(
  (appusers) => {
    history.push({pathname: `${ RouteName.APP_DETAIL}${appusers?.id}`, state: { appusers }})
   
  },
  [setData]
);
const handleExport = useCallback(()=> {
  setIsSubmitting(true);
  serviceExportAppUsersList({
    index: 1,
    row: sortingData?.row,
    order: sortingData?.order,
    query: query,
    query_data: queryData,
  }).then((res) => {
    if (!res.error) {
      const data = res.data;
      window.open(data, "_blank");
    }
    setIsSubmitting(false);
  });
}, [sortingData, query, queryData, setIsSubmitting]);
 

  return {
    handlePageChange,
    handleFilterDataChange,
    handleSearchValueChange,
    handleSortOrderChange,
    handleEdit,
    isSidePanel,
    handleSideToggle,
    editData,
    configFilter,
    handleEditSidePannel,
    handleDetail,
    handleExport,
    isSubmitting
  };
};

export default useAppUsersListHook;
